import { combineReducers } from 'redux';
import catalog from './catalog';
import center from './center';
import statuses from './statuses';

export default combineReducers({
  entities: combineReducers({ catalog, center }),
  statuses,
});
